module.exports = __webpack_public_path__ + "static/media/12_ritsue6e48c236b8caba9a7a15a15eb161919.webp";